import { types } from "../action-types";

const initialState = {
  loading: false,
  departments: [],
  error: false,
};

const departmentSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_DEPARTMENTS_INIT:
      return { ...state, loading: true, error: false };
    case types.SEARCH_DEPARTMENTS_SUCCESS:
      return { ...state, loading: false, departments: action.payload };
    case types.SEARCH_DEPARTMENTS_FAILURE:
      return { ...state, loading: false, departments: [], error: true };
    default:
      return state;
  }
};

export default departmentSearchReducer;
